<template>
  <div class="register">
    <div class="title">填写账号信息</div>
    <div class="formbox">
      <el-form class="formbox" label-width="110px">
        <el-form-item label="公司名称：">
          <el-input v-model="formData.companyName"></el-input>
        </el-form-item>
        <el-form-item label="所属地区：">
          <el-select
            v-model="formData.provinceName"
            placeholder="省"
            @change="handleProvince"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.cityName"
            placeholder="市"
            @change="handleCity"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in cityList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.districtName"
            placeholder="区"
            @change="handleArea"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in areaList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登陆手机号：">
          <el-input v-model="formData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          <el-input v-model="formData.verifyCode"></el-input>
          <el-button @click="getVerifCode">{{btnText}}</el-button>
        </el-form-item>
        <el-form-item label="设置登录密码：">
          <el-input type="password" v-model="formData.passWord"></el-input>
        </el-form-item>
        <!-- <el-form-item label="确认登录密码：">
          <el-input></el-input>
        </el-form-item> -->
        <el-form-item label="邀请码：">
          <el-input v-model="formData.inviteCode"></el-input>
        </el-form-item>
        <el-form-item label-width="280px">
          <el-button type="danger" @click="submitBtn">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  AreaList,
  GetMobileVerifyCode,
  GetTestVerifyCode,
  DealerRegister,
  requestLogin
} from '../api/api'
export default {
  data(){
    return{
      btnText: '获取验证码',
      formData: {
        companyName: '',
        mobile: '',
        verifyCode: '',
        provinceId: null,
        provinceName: '',
        cityId: null,
        cityName: '',
        districtId: null,
        districtName: '',
        passWord: '',
        inviteCode: ''
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      submiting: false,
    }
  },
  created(){
    this.getProvinceList()
  },
  methods:{
    getVerifCode(){
      let params = {
        mobile: this.formData.mobile,
        codeType: 10
      }
      GetMobileVerifyCode(params).then(res =>{
        if(res.data.success){
          this.count = 60
          setInterval(() => {
            if (this.count > 1) {
              this.count--
              this.btnText = `倒计时${this.count}`
            } else {
              this.btnText = '获取验证码'
              this.counting = false
            }
          }, 1000)
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    submitBtn(){
      if (this.submiting) {
        return false
      }
      if (!this.formData.companyName) {
        return this.$message.error('请填写公司名称！')
      }
      if (!this.formData.provinceName) {
        return this.$message.error('请选着地址！')
      }
      if (!this.formData.companyName) {
        return this.$message.error('请填写登录手机号！')
      }
      if (!this.formData.companyName) {
        return this.$message.error('请填写验证码！')
      }
      if (!this.formData.companyName) {
        return this.$message.error('请填写登录密码！')
      }
      this.submiting = true
      DealerRegister(this.formData).then(res => {
        if(res.data.success){
          this.login()
        } else {
          this.submiting = false
          this.$message.error(res.data.msg)
        }
      })
    },
    login(){
      let params = {
        mobile: this.formData.mobile,
        password: this.formData.passWord
      }
      requestLogin(params).then(res => {
        if(res.success){
          this.$router.push('/home')
          this.$store.commit("setLoginType", true)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getProvinceList(){
      let params = {
        areaLevel: 1
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.provinceList = res.data.response.data;
          if (this.formData.provinceId) {
            this.getCityList();
          }
        }
      })
    },
    getCityList(){
      let params = {
        parentId: this.formData.provinceId
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.cityList = res.data.response.data;
          if (this.formData.cityId) {
            this.getAreaList();
          }
        }
      })
    },
    getAreaList(){
      let params = {
        parentId: this.formData.cityId
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.areaList = res.data.response.data;
        }
      })
    },
    handleProvince(val){
      this.formData.provinceId = val.Id
      this.formData.provinceName = val.AreaName
      this.formData.cityId = null
      this.formData.cityName = ''
      this.formData.districtId = null
      this.formData.districtName = ''
      this.getCityList()
    },
    handleCity(val){
      this.formData.cityId = val.Id
      this.formData.cityName = val.AreaName
      this.formData.districtId = null
      this.formData.districtName = ''
      this.getAreaList()
    },
    handleArea(val){
      this.formData.districtId = val.Id
      this.formData.districtName = val.AreaName
    },
  }
}
</script>
<style lang="scss" scoped>
.register{
  width: 1200px;
  margin: 0 auto;
  // text-align: left;
}
.title{
  width: 800px;
  margin: 0 auto;
  text-align: left;
  padding-top: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}
.formbox{
  width: 800px;
  margin: 0 auto;
  text-align: left;
  // margin-left: 50px;
  padding: 30px 0;
}
.el-input{
  width: 450px;
}
</style>